/* cart-drawer.js - BONIFAKTUR AJAX cart drawer */
(function () {
  'use strict';

  const drawer   = document.getElementById('cart-drawer');
  const overlay  = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;

  const itemsEl   = drawer.querySelector('[data-cart-items]');
  const totalEl   = drawer.querySelector('[data-cart-total]');
  const shipFill  = drawer.querySelector('[data-ship-fill]');
  const shipMsg   = drawer.querySelector('[data-ship-msg]');
  const shipCur   = drawer.querySelector('[data-ship-current]');
  const shipBar   = drawer.querySelector('[data-ship-bar]');
  const threshold = parseInt(shipBar?.dataset.threshold || '0', 10);
  const shipZone  = shipBar?.dataset.thresholdZone || 'WORLD';

  function fmt(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  // ── Open / Close ──────────────────────────────────────────────────────────

  function open() {
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Body flag so CSS can hide third-party widgets (Shopify Inbox chat,
    // UserWay accessibility, app pills) that inject themselves at body
    // level with their own max z-indexes - our drawer can't z-index past
    // them when they're a sibling of <body> or live in a separate
    // browsing context.
    document.body.classList.add('cart-drawer-open');
    refresh();
    setTimeout(() => {
      const first = drawer.querySelector('button:not([disabled]), [href]');
      if (first) first.focus();
    }, 50);
  }

  function close() {
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-drawer-open');
    // Return focus to the trigger that opened the drawer
    if (drawer._trigger) { drawer._trigger.focus(); drawer._trigger = null; }
  }

  overlay.addEventListener('click', close);
  drawer.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      drawer._trigger = btn;
      open();
    });
  });

  // ── Ship bar ──────────────────────────────────────────────────────────────

  function updateShipBar(totalCents) {
    if (shipFill && threshold > 0) shipFill.style.width = Math.min(100, (totalCents / threshold) * 100) + '%';
    if (shipCur)  shipCur.textContent  = fmt(totalCents);
    if (!shipMsg) return;
    if (threshold === 0) {
      shipMsg.innerHTML = bfT('ship_calc_checkout', 'Versandkosten werden im Checkout berechnet.');
      return;
    }
    const rem = threshold - totalCents;
    shipMsg.innerHTML = rem > 0
      ? bfT('ship_free_remaining_html', 'Noch <b>{amount}</b> bis zum kostenlosen Versand ({zone}).').replace('{amount}', fmt(rem)).replace('{zone}', shipZone)
      : bfT('ship_free_html', 'Versand <b>frei</b> ({zone}).').replace('{zone}', shipZone);
  }

  // ── Header count ──────────────────────────────────────────────────────────

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count > 0 ? `(${count})` : '';
      el.classList.remove('cart-count--bump');
      void el.offsetWidth;
      el.classList.add('cart-count--bump');
      el.addEventListener('animationend', () => el.classList.remove('cart-count--bump'), { once: true });
    });
  }

  // ── Render items ──────────────────────────────────────────────────────────

  function renderItems(items) {
    if (!itemsEl) return;
    if (!items.length) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty t-mono">' + bfT('cart_empty', 'Dein Warenkorb ist leer.') + '</p>';
      return;
    }
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    itemsEl.innerHTML = items.map((item, i) => {
      const imgSrc = item.featured_image?.url
        ? item.featured_image.url.replace(/(\.\w+)(\?\S*)?$/, '_160x160$1$2')
        : '';
      const variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-drawer__item-meta t-mono">${esc(item.variant_title)}</p>` : '';
      const props = item.properties || {};
      const kitName = props['Anleitung'];
      const kitUse  = props['Verwendung'];
      const kitSize = props['Größe'];
      const kitLine = kitName
        ? `<p class="cart-drawer__item-kit t-mono">Teil von <b>${esc(kitName)}</b>${kitUse ? ' · ' + esc(kitUse) : ''}${kitSize ? ' · Gr. ' + esc(kitSize) : ''}</p>`
        : '';
      const inKitClass = kitName ? ' cart-drawer__item--in-kit' : '';
      return `
        <div class="cart-drawer__item${inKitClass}" data-line="${i + 1}">
          <a class="cart-drawer__item-img" href="${item.url}" tabindex="-1" aria-hidden="true">
            ${imgSrc ? `<img src="${imgSrc}" alt="${esc(item.title)}" width="80" height="80" loading="lazy">` : ''}
          </a>
          <div class="cart-drawer__item-body">
            ${kitLine}
            <p class="cart-drawer__item-vendor t-mono">${esc(item.vendor)}</p>
            <p class="cart-drawer__item-name">${esc(item.product_title)}</p>
            ${variantLine}
            <div class="cart-drawer__stepper">
              <button type="button" class="cart-drawer__step" data-step="-1" data-line="${i + 1}" aria-label="Weniger">−</button>
              <span class="cart-drawer__qty t-mono">${item.quantity}</span>
              <button type="button" class="cart-drawer__step" data-step="1" data-line="${i + 1}" aria-label="Mehr">+</button>
            </div>
          </div>
          <div class="cart-drawer__item-right">
            <p class="cart-drawer__item-price">${fmt(item.line_price)}</p>
            <button type="button" class="cart-drawer__remove t-mono" data-remove data-line="${i + 1}">Entfernen</button>
          </div>
        </div>`;
    }).join('');
    // EU Gewährleistungslabel: keep it at the end of the list for physical goods.
    const notice = document.querySelector('template[data-guarantee-notice]');
    if (notice && items.some(item => item.requires_shipping)) {
      itemsEl.appendChild(notice.content.cloneNode(true));
    }
    bindItemEvents();
  }

  function bindItemEvents() {
    if (!itemsEl) return;
    itemsEl.querySelectorAll('[data-step]').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = parseInt(btn.dataset.line, 10);
        const step = parseInt(btn.dataset.step, 10);
        const qtyEl = btn.closest('.cart-drawer__item').querySelector('.cart-drawer__qty');
        const current = parseInt(qtyEl?.textContent || '1', 10);
        const newQty = current + step;
        if (newQty < 1) {
          btn.closest('.cart-drawer__item').classList.add('cart-drawer__item--removing');
          setTimeout(() => changeLine(line, 0), 240);
        } else {
          changeLine(line, newQty);
        }
      });
    });
    itemsEl.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.cart-drawer__item').classList.add('cart-drawer__item--removing');
        setTimeout(() => changeLine(parseInt(btn.dataset.line, 10), 0), 240);
      });
    });
  }

  // ── AJAX ──────────────────────────────────────────────────────────────────

  function refresh() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(applyCart)
      .catch(() => {});
  }

  function changeLine(line, qty) {
    // Shopify rejects qty > stock on tracked variants with policy "deny" —
    // returns 422 with a body like {description: "All 3 ... are in your
    // cart"}. Surface that as a toast and re-render with the actual,
    // server-clamped cart so the user's UI doesn't drift from reality.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    })
      .then(r => r.json().then(body => ({ ok: r.ok, body })))
      .then(({ ok, body }) => {
        if (!ok && body && (body.description || body.message)) {
          showCartToast(body.description || body.message);
          return fetch('/cart.js').then(r => r.json()).then(applyCart);
        }
        applyCart(body);
      })
      .catch(() => {});
  }

  function showCartToast(msg) {
    let toast = drawer.querySelector('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-drawer__toast';
      toast.dataset.cartToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      drawer.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  function applyCart(cart) {
    renderItems(cart.items);
    if (totalEl) totalEl.textContent = fmt(cart.total_price);
    updateShipBar(cart.total_price);
    updateBoniPoints(cart.total_price);
    updateCount(cart.item_count);
    // Notify analytics (Matomo etc.) that the cart state has been written.
    // Fired on add (via boni:cart:added handler), qty change, remove, and
    // upsell — but NOT on the initial /cart.js load below, which only
    // updates the ship-bar without going through applyCart.
    document.dispatchEvent(new CustomEvent('boni:cart:applied', { detail: cart }));
  }

  function updateBoniPoints(totalCents) {
    // Same formula as snippets/boni-points-line.liquid: floor(€) × 10.
    const pts = Math.floor(totalCents / 100) * 10;
    drawer.querySelectorAll('[data-boni-points]').forEach(el => {
      el.textContent = pts;
    });
  }

  // ── Listen for add-to-cart events from product/kit JS ─────────────────────

  document.addEventListener('boni:cart:added', e => {
    applyCart(e.detail);
    open();
  });

  // ── Cart upsells (works on /cart page and inside the drawer) ──────────────

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    const id = btn.dataset.variantId;
    if (!id || btn.disabled) return;

    btn.disabled = true;
    const onCartPage = !!document.querySelector('.cart-page');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      });
      if (!res.ok) {
        // Stock cap (422) — show the message Shopify returns so the user
        // knows it's not a generic error.
        const body = await res.json().catch(() => null);
        if (body && (body.description || body.message)) {
          showCartToast(body.description || body.message);
        }
        throw new Error('Cart error');
      }
      btn.classList.add('is-success');
      btn.textContent = '✓';

      if (onCartPage) {
        // Server renders cart-items + upsells in Liquid; reload to refresh both.
        setTimeout(() => window.location.reload(), 350);
      } else {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        applyCart(cart);
        // Fade the just-added upsell so it doesn't suggest re-adding itself.
        const card = btn.closest('.cart-upsell');
        setTimeout(() => {
          if (card) {
            card.style.transition = 'opacity 240ms ease, transform 240ms ease';
            card.style.opacity = '0';
            card.style.transform = 'translateY(-4px)';
            setTimeout(() => card.remove(), 260);
          }
        }, 600);
      }
    } catch {
      btn.disabled = false;
    }
  });

  // ── Init ship bar from live cart ──────────────────────────────────────────

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateShipBar(cart.total_price);
      updateCount(cart.item_count);
    })
    .catch(() => {});

  window.BoniCart = { open, close, refresh };

})();
